import React, { useState } from "react";
import { F1CarSVG } from "./F1CarSVG";

export const RealCar = ({
  src,
  sources = [],
  direction = "ltr",
  startY = "32vh",
  width = 360,
  duration = 5,
  delay = 0,
  tint,
  showDebug = false,
}) => {
  const [idx, setIdx] = useState(0);
  const list = src ? [src, ...sources] : sources;
  const current = list[idx];
  const anim =
    direction === "ltr"
      ? `animate-[carFlyL_${duration}s_ease-in-out_${delay}s_1]`
      : `animate-[carFlyR_${duration}s_ease-in-out_${delay}s_1]`;

  if (!current) {
    return (
      <div>
       
        <F1CarSVG
          direction={direction === "ltr" ? "ltr" : "rtl"}
          primary={tint || "#e10600"}
          accent="#ffffff"
          startY={startY}
          duration={duration}
          delay={delay}
        />
      </div>
    );
  }

  return (
    <img
      src={current}
      alt="F1 car"
      onError={() => setIdx((i) => i + 1)}
      className={`pointer-events-none absolute drop-shadow-[0_10px_20px_rgba(0,0,0,.6)] ${anim}`}
      style={{
        top: startY,
        width,
        objectFit: "contain",
        imageRendering: "auto",
        transform: direction === "rtl" ? "scaleX(-1)" : undefined,
        transformOrigin: "center",
        left: direction === "ltr" ? 0 : "auto",
        right: direction === "rtl" ? 0 : "auto",
      }}
    />
  );
};
